import {
  Action,
  Entities,
  mergeEntities,
  Reducer,
  ListReducer,
} from '../store';
import { NotificationsPreference } from './notifications.model';

export const notificationsUserPreferencesReducer: ListReducer<
  'notificationsUserPreferences'
> = (state = {}, action) => {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (
        action.payload &&
        action.payload.ref.path[0] === 'notificationsUserPreferences'
      ) {
        const { data, ref } = action.payload;
        return mergeEntities<'notificationsUserPreferences'>(
          state,
          transformNotificationsUserPreferences(data),
          ref,
        );
      }
      return state;
    case 'API_POST_SUCCESS': {
      if (
        action.payload &&
        action.payload.ref.path[0] === 'notificationsUserPreferences'
      ) {
        const { data, ref } = action.payload;
        return mergeEntities<'notificationsUserPreferences'>(
          state,
          transformNotificationsUserPreferences(data),
          ref,
        );
      }
      return state;
    }
    default:
      return state;
  }
};

function transformNotificationsUserPreferences(data: any) {
  return data.reduce(
    (obj: { [channel: string]: NotificationsPreference }, setting: any) => {
      obj[setting.channel] = {
        channel: setting.channel,
        name: setting.name,
        order: setting.order,
        enabled: setting.enabled,
        notify: setting.notify,
        header: setting.header,
        notificationType: setting.notificationType,
      };
      return obj;
    },
    {},
  );
}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/notifications/notifications.reducer.ts